import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId/workspace/records/$recordId/_drawer/activity",
)({
	/** Tab body is composed by the drawer layout into Figma `Details`. */
	component: () => null,
});
